module.exports = __webpack_public_path__ + "media/promo/hoch2023ru/images/rec-10-b96a90d51f69878bb6a38fff3ac604bb.jpg";